import PmaxAssetGroupPage from '@/components/google-ads/performance-max/PmaxAssetGroupPage';
import { SALES_OBJECTIVE } from './salesObjective';

/** ADD ASSET GROUPS TO A SALES CAMPAIGN — /google-ads/sales/create/assetgroup */
export default function CreateSalesAssetGroup() {
  return <PmaxAssetGroupPage objective={SALES_OBJECTIVE} />;
}
